import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["level", "className", "fontWeight", "color"];
import React from 'react';
import { Classes } from '@blueprintjs/core';
import classNames from 'classnames';
import Box from './Box';
var Heading = function Heading(_ref) {
  var level = _ref.level,
    className = _ref.className,
    fontWeight = _ref.fontWeight,
    color = _ref.color,
    rest = _objectWithoutProperties(_ref, _excluded);
  if (level <= 2 && !fontWeight) {
    // @ts-expect-error yeah this is invalid code but I don't want to mess with it right now
    fontWeight = 'heavy';
  }
  if (!level) {
    console.warn('Heading specified with no level');
  }
  return /*#__PURE__*/React.createElement(Box, _extends({
    fontWeight: fontWeight,
    color: color || undefined
  }, rest, {
    "aria-level": level,
    as: "h".concat(level),
    className: classNames(Classes.HEADING, className)
  }));
};
export default Heading;